export default "__VITE_ASSET__CDc1fCx0__"